import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../CSS/Layouts/Connect.css";
import { saveContactInquiry } from "../utils/firebaseFunctions.js";
import YusefCopyright from "../Images/YusefCopyright.png";

const serviceOptions = ["Commercial Content", "Event Campaigns"];

function Connect({ connectPrefillRequest: propPrefillRequest }) {
  const location = useLocation();
  const connectPrefillRequest = location.state?.connectPrefillRequest ?? propPrefillRequest;
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    projectDetails: "",
    selectedServices: [],
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: "idle", message: "" });

  useEffect(() => {
    if (!connectPrefillRequest?.requestId) return;

    setFormData((currentFormData) => ({
      ...currentFormData,
      selectedServices: connectPrefillRequest.selectedServices || [],
    }));

    if (submitStatus.type !== "idle") {
      setSubmitStatus({ type: "idle", message: "" });
    }
  }, [connectPrefillRequest, submitStatus.type]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((currentFormData) => ({
      ...currentFormData,
      [name]: value,
    }));

    if (submitStatus.type !== "idle") {
      setSubmitStatus({ type: "idle", message: "" });
    }
  };

  const handleServiceToggle = (service) => {
    setFormData((currentFormData) => {
      const isSelected = currentFormData.selectedServices.includes(service);

      return {
        ...currentFormData,
        selectedServices: isSelected
          ? currentFormData.selectedServices.filter((item) => item !== service)
          : [...currentFormData.selectedServices, service],
      };
    });

    if (submitStatus.type !== "idle") {
      setSubmitStatus({ type: "idle", message: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName, email, projectDetails, selectedServices } = formData;

    if (!firstName.trim() || !lastName.trim() || !email.trim() || !projectDetails.trim()) {
      setSubmitStatus({
        type: "error",
        message: "Please complete all fields before submitting.",
      });
      return;
    }

    try {
      setIsSubmitting(true);
      await saveContactInquiry({
        firstName,
        lastName,
        email,
        projectDetails,
        selectedServices,
      });

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        projectDetails: "",
        selectedServices: [],
      });
      setSubmitStatus({
        type: "success",
        message: "Your inquiry has been sent.",
      });
    } catch (error) {
      console.error("Error sending inquiry:", error);
      setSubmitStatus({
        type: "error",
        message: error.message || "There was an error. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="connect-content">
      <div className="connect-form-shell">
        <form className="connect-form" onSubmit={handleSubmit}>
          <div className="connect-fieldset">
            <label className="connect-label" htmlFor="firstName">
              Name*
            </label>
            <div className="connect-name-row">
              <div className="connect-input-group">
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  className="connect-input"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="connect-input-group">
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  className="connect-input"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
          </div>

          <div className="connect-fieldset">
            <label className="connect-label" htmlFor="email">
              Email*
            </label>
            <div className="connect-input-group connect-input-group--full">
              <input
                id="email"
                name="email"
                type="email"
                className="connect-input"
                placeholder="Work Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="connect-fieldset connect-fieldset--message">
            <label className="connect-label connect-label--message" htmlFor="projectDetails">
              Briefly explain what you are looking for or how we can partner
            </label>
            <div className="connect-service-options" aria-label="Select services of interest">
              {serviceOptions.map((service) => {
                const isSelected = formData.selectedServices.includes(service);

                return (
                  <button
                    key={service}
                    type="button"
                    className={`connect-service-chip ${isSelected ? "is-selected" : ""}`}
                    onClick={() => handleServiceToggle(service)}
                    aria-pressed={isSelected}
                  >
                    {service}
                  </button>
                );
              })}
            </div>
            <div className="connect-input-group connect-input-group--full">
              <textarea
                id="projectDetails"
                name="projectDetails"
                className="connect-textarea"
                value={formData.projectDetails}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="connect-actions">
            {submitStatus.message ? (
              <p className="connect-status" role="status" aria-live="polite">
                {submitStatus.message}
              </p>
            ) : null}
            <button className="connect-submit" type="submit" disabled={isSubmitting}>
              {isSubmitting ? <span className="connect-submit-spinner" aria-hidden="true" /> : null}
              <span>{isSubmitting ? "SENDING" : "SUBMIT"}</span>
            </button>
          </div>
        </form>
      </div>
      <img
        src={YusefCopyright}
        alt="Copyright of Yusef"
        className="connect-copyright"
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}

export default Connect;
 